import { ActionType, IAction } from '@/types/action';
import { IClaimState } from '@/types/claim';

export const initialState: IClaimState = {
  claim: {
    id: '',
    policyId: '',
    claimNumber: '',
    companyId: '',
    claimFiler: '',
    claimBeneficiary: '',
    createdAt: '',
    updatedAt: '',
    completedAt: null,
    claimType: '',
    currentAgentId: '',
    status: '',
    current_stage: '',
    additionalNotes: '',
    sicId: '',
    poNumber: '',
    insuredIndividualId: '',
  },
  inspection: {
    id: '',
    claimId: '',
    inspectionDate: '',
    inspector: '',
    isVirtual: false,
    location: '',
    croquisLink: '',
    status: '',
    notes: '',
    createdAt: '',
  },
  incident: {
    id: '',
    claimId: '',
    incidentType: '',
    incidentDate: '',
    location: '',
    policeReportNumber: '',
    additionalNotes: '',
    wasPolicePresent: '',
    policeBadgeNumber: '',
    policeStationName: '',
    policeOfficerName: '',
    numberOfVehiclesInvolved: '',
    carDamages: '',
  },
  policy: {
    id: '',
    primaryPolicyHolderId: '',
    policyNumber: 0,
    effectiveDate: '',
    expirationDate: '',
    policyType: '',
    policyLink: '',
    companyId: '',
  },
  personsInvolved: [],
  vehiclesInvolved: [],
  flags: [],
  auditTrail: {
    entries: [],
  },
};

const claimReducer = (state: IClaimState, action: IAction) => {
  switch (action.type) {
    case ActionType.SET_CURRENT_CLAIM:
      return {
        ...state,
        claim: action.payload,
      };
    case ActionType.UPDATE_CLAIM_STATUS:
      return {
        ...state,
        claim: {
          ...state.claim,
          status: action.payload.status,
        },
      };
    case ActionType.UPDATE_CLAIM_STAGE:
      return {
        ...state,
        claim: {
          ...state.claim,
          current_stage: action.payload.stage,
        },
      };
    case ActionType.RESET_CLAIM_STATE:
      return initialState;

    case ActionType.SET_CLAIM_POLICY:
      return {
        ...state,
        policy: action.payload,
      };
    case ActionType.SET_CLAIM_INSPECTION:
      return {
        ...state,
        inspection: action.payload,
      };

    case ActionType.UPDATE_CLAIM_FLAGS:
      return {
        ...state,
        flags: action.payload,
      };

    case ActionType.SET_CLAIM_INCIDENT:
      return {
        ...state,
        incident: action.payload,
      };
    case ActionType.SET_CLAIM_PEOPLE_INVOLVED:
      return {
        ...state,
        personsInvolved: action.payload,
      };
    case ActionType.SET_CLAIM_VEHICLES_INVOLVED:
      return {
        ...state,
        vehiclesInvolved: action.payload,
      };

    case ActionType.SET_CLAIM_FLAGS:
      return {
        ...state,
        flags: action.payload,
      };
    case ActionType.SET_CLAIM_AUDIT_TRAIL:
      return {
        ...state,
        claim: {
          ...state.claim,
          auditTrail: action.payload,
        },
        auditTrail: action.payload,
      };
    default:
      return state;
  }
};
export default claimReducer;
